export default {
	id: 'SIMPLE_ASSESSMENT_14_99',
	providers: {
		paltaMap: {
			USD: 'simple_self_assessment_14_99_usd',
			EUR: 'simple_self_assessment_14_99_eur',
			GBP: 'simple_self_assessment_14_99_gbp',
			CAD: 'simple_self_assessment_21_99_cad',
			AUD: 'simple_self_assessment_23_99_aud',
			DKK: 'simple_self_assessment_99_99_dkk',
			SEK: 'simple_self_assessment_149_99_sek',
			NOK: 'simple_self_assessment_155_99_nok',
			BRL: 'simple_self_assessment_85_brl',
			MXN: 'simple_self_assessment_299_mxn',
			TRY: 'simple_self_assessment_569_try',
		},
		primer: 'prd_04FMPs52jLxL',
	},
	model: {},
	trial: {
		priceMap: {
			USD: 14.99,
			EUR: 14.99,
			GBP: 14.99,
			CAD: 21.99,
			AUD: 23.99,
			DKK: 99.99,
			SEK: 149.99,
			NOK: 155.99,
			BRL: 85.0,
			MXN: 299.0,
			TRY: 569.0,
		},
		originalPriceMap: {
			USD: 24.99,
			EUR: 24.99,
			GBP: 24.99,
			CAD: 36.0,
			AUD: 40.0,
			DKK: 170.0,
			SEK: 250.0,
			NOK: 260.0,
			BRL: 140.0,
			MXN: 500.0,
			TRY: 950.0,
		},
	},
	subscription: {
		priceMap: {
			USD: 14.99,
			EUR: 14.99,
			GBP: 14.99,
			CAD: 21.99,
			AUD: 23.99,
			DKK: 99.99,
			SEK: 149.99,
			NOK: 155.99,
			BRL: 85.0,
			MXN: 299.0,
			TRY: 569.0,
			// PLN: 57.99,
			// ARS: 15990.0,
			// COP: 62490.0,
			// CLP: 13990.0,
		},
	},
	options: () => ({}),
}
